// WORKING FINE ON WEB
// import React, { useEffect, useRef, useState } from "react";
// import { QRCodeCanvas } from "qrcode.react";
// import { v4 as uuidv4 } from "uuid";
// import { API, QR_AUTH_API } from "../Utils/API";
// import logo from "../Assets/Secar_logo/logo.png";
// import noInternet from "../Assets/no_internet.png";
// import { useLocation } from "react-router-dom";



// export default function QRLogin() {
//   const BASE_URL = process.env.REACT_WEB;
//   const [status, setStatus] = useState("SYSTEM READY");
//   const [countdown, setCountdown] = useState(30);
//   const [qrValue, setQrValue] = useState("");
//   const [isOnline, setIsOnline] = useState(navigator.onLine);
//   const location = useLocation();
// const cart = location.state?.cart || JSON.parse(localStorage.getItem("cart") || "[]");
// const totalAmount = location.state?.totalAmount || localStorage.getItem("totalAmount") || 0;

  
//   // States for Flow
//   const [isVerifying, setIsVerifying] = useState(false);
//   const [showPaymentHub, setShowPaymentHub] = useState(false);
//   const [userData, setUserData] = useState(null);
//   const [selectedBank, setSelectedBank] = useState(null);
//   const [theme, setTheme] = useState("dark");
//   const [debugPayload, setDebugPayload] = useState(null);
//   const [paymentTimer, setPaymentTimer] = useState(180); // 180 Seconds

//   const qrIntervalRef = useRef(null);
//   const checkIntervalRef = useRef(null);
//   const [dots, setDots] = useState("");
//   const [permissionError, setPermissionError] = useState(null);
// const [selectedMethod, setSelectedMethod] = useState(null);
// const [isProcessing, setIsProcessing] = useState(false);
// const [paymentSuccess, setPaymentSuccess] = useState(false);

//   const paymentOptions = {
//     "Bank 1": ["Credit Card", "Debit Card", "Net Banking"],
//     "Bank 2": ["Credit Card", "Debit Card", "Net Banking"],
//     "Bank 3": ["Credit Card", "Debit Card", "Net Banking"],
//     "Bank 4": ["Credit Card", "Debit Card", "Net Banking"],
//     "Other Bank": ["Credit Card", "Debit Card", "Net Banking"], 
//   };

//   useEffect(() => {
//   let interval = null;
//   if (showPaymentHub && paymentTimer > 0 && !paymentSuccess) {
//     interval = setInterval(() => {
//       setPaymentTimer((prev) => prev - 1);
//     }, 1000);
//   } else if (paymentTimer === 0) {
//     // Session Expired Logic
//     alert("SECURE SESSION EXPIRED");
//     setShowPaymentHub(false);
//     setSelectedMethod(null);
//     setPaymentTimer(180);
//   }
//   return () => clearInterval(interval);
// }, [showPaymentHub, paymentTimer, paymentSuccess]);

// // Helper to format seconds to MM:SS
// const formatTime = (seconds) => {
//   const mins = Math.floor(seconds / 60);
//   const secs = seconds % 60;
//   return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
// };

//   // 1. Connection Monitoring
//   useEffect(() => {
//     const handleOnline = () => setIsOnline(true);
//     const handleOffline = () => setIsOnline(false);
//     window.addEventListener("online", handleOnline);
//     window.addEventListener("offline", handleOffline);
//     return () => {
//       window.removeEventListener("online", handleOnline);
//       window.removeEventListener("offline", handleOffline);
//     };
//   }, []);

//   // 2. Lifecycle & QR Generation
//   useEffect(() => {
//     if (!isOnline) {
//       setStatus("OFFLINE");
//       clearInterval(qrIntervalRef.current);
//       clearInterval(checkIntervalRef.current);
//       return;
//     }
//     generateQR();
//     qrIntervalRef.current = setInterval(generateQR, 30000);
//     return () => {
//       clearInterval(qrIntervalRef.current);
//       clearInterval(checkIntervalRef.current);
//     };
//   }, [isOnline]);

//   // 3. UI Animations (Dots & Timer)
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setDots((prev) => (prev.length >= 3 ? "" : prev + "."));
//     }, 500);
//     const timer = setInterval(() => {
//       if (isOnline) setCountdown((prev) => (prev <= 1 ? 30 : prev - 1));
//     }, 1000);
//     return () => {
//       clearInterval(interval);
//       clearInterval(timer);
//     };
//   }, [isOnline]);

//   // --- Security & Data Helpers ---
//   const getIP = async () => {
//     try {
//       const res = await fetch("https://api.ipify.org?format=json");
//       const data = await res.json();
//       return data.ip;
//     } catch { return "0.0.0.0"; }
//   };

//   const getLocation = () => {
//     return new Promise((resolve, reject) => {
//       if (!navigator.geolocation) return reject("Not supported");
//       navigator.geolocation.getCurrentPosition(
//         (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy }),
//         (err) => reject(err),
//         { enableHighAccuracy: true, timeout: 10000 }
//       );
//     });
//   };

//   // Add this helper function above your generateQR function
// const getMaximumWebData = async () => {
//   const nav = navigator;
//   const screen = window.screen;
//   const conn = nav.connection || nav.mozConnection || nav.webkitConnection || {};
  
//   // 1. Try to fetch Battery Status (Supported in Chrome/Edge, not Safari)
//   let batteryData = { supported: false };
//   try {
//     if (nav.getBattery) {
//       const b = await nav.getBattery();
//       batteryData = {
//         supported: true,
//         level: Math.round(b.level * 100) + "%",
//         charging: b.charging,
//         chargingTime: b.chargingTime,
//         dischargingTime: b.dischargingTime
//       };
//     }
//   } catch (e) { /* silent fail */ }

//   // 2. Extract GPU / Graphics Card Info via WebGL (Highly unique)
//   let gpuRenderer = "unknown";
//   let gpuVendor = "unknown";
//   try {
//     const canvas = document.createElement("canvas");
//     const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
//     if (gl) {
//       const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
//       if (debugInfo) {
//         gpuVendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
//         gpuRenderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
//       }
//     }
//   } catch (e) { /* silent fail */ }

//   return {
//     hardware: {
//       cpuLogicalCores: nav.hardwareConcurrency || "unknown",
//       ramGB: nav.deviceMemory || "unknown",
//       maxTouchPoints: nav.maxTouchPoints || 0,
//       gpuVendor: gpuVendor,
//       gpuRenderer: gpuRenderer,
//       battery: batteryData
//     },
//     screenMetrics: {
//       width: screen.width,
//       height: screen.height,
//       availWidth: screen.availWidth,
//       availHeight: screen.availHeight,
//       colorDepth: screen.colorDepth,
//       pixelDepth: screen.pixelDepth,
//       pixelRatio: window.devicePixelRatio || 1,
//       isExtendedDisplay: screen.isExtended || false
//     },
//     networkTelemetry: {
//       connectionType: conn.type || "unknown",
//       effectiveSpeed: conn.effectiveType || "unknown",
//       downlinkMbps: conn.downlink || "unknown",
//       roundTripTimeMs: conn.rtt || "unknown",
//       dataSaverActive: conn.saveData || false
//     },
//     systemEnvironment: {
//       platform: nav.platform,
//       vendor: nav.vendor,
//       osLanguage: nav.language,
//       installedLanguages: nav.languages || [],
//       timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//       timeOffsetMinutes: new Date().getTimezoneOffset(),
//       pdfViewerEnabled: nav.pdfViewerEnabled || false,
//       cookiesEnabled: nav.cookieEnabled || false,
//       doNotTrackStatus: nav.doNotTrack || "unspecified"
//     },
//     browserAPISupport: {
//       bluetooth: !!nav.bluetooth, 
//       usb: !!nav.usb,             
//       nfc: 'NDEFReader' in window, 
//       gamepad: !!nav.getGamepads  
//     },
//     threatDetection: {
//       isBotOrWebdriver: nav.webdriver || false,
//       userAgent: nav.userAgent
//     }
//   };
// };

// // ----------------------------------------------------
// // YOUR UPDATED generateQR FUNCTION
// // ----------------------------------------------------

// const generateQR = async () => {
//   if (!isOnline || isVerifying || showPaymentHub) return;
  
//   try {
//     const ip = await getIP();
//     let location;
//     try {
//       location = await getLocation();
//     } catch (err) {
//       setPermissionError("LOCATION_DENIED");
//       return;
//     }

//     setPermissionError(null);
//     // 1. Fetch the massive environment profile
//     const deepEnv = await getMaximumWebData();
//     // 2. Build the ultra-secure payload
//     const payload = {
//       sessionId: uuidv4(),
//       ip,
//       location,
//       environment: deepEnv,
    
//       securityFingerprint: btoa(
//         `${deepEnv.hardware.gpuRenderer}|${deepEnv.screenMetrics.width}x${deepEnv.screenMetrics.height}|${deepEnv.systemEnvironment.timezone}`
//       ),
      
//       meta: { 
//         timestamp: new Date().toISOString(), 
//         referrer: document.referrer || "direct" 
//       }
//     };

//     setDebugPayload(payload);

//     const res = await API.post(QR_AUTH_API.GET_GENERATE_QR, payload);
//     const data = res.data;
    
//     setQrValue(`${BASE_URL}?token=${data.token}`);
//     setCountdown(30);
//     setStatus("WAITING FOR SCAN");
    
//     startChecking(data.token);
//   } catch (err) {
//     setStatus("SERVER ERROR");
//   }
// };
//   const startChecking = (token) => {
//     if (checkIntervalRef.current) clearInterval(checkIntervalRef.current);
//     checkIntervalRef.current = setInterval(async () => {
//       try {
//         const res = await API.get(`/auth/check/${token}`);
//         const data = res.data;

//         if (data.status === "approved") {
//           setIsVerifying(true);
//           setUserData(data.user);
//           clearInterval(checkIntervalRef.current);
//           clearInterval(qrIntervalRef.current);
          
//           // Success Transition
//           setTimeout(() => {
//             setIsVerifying(false);
//             setShowPaymentHub(true);
//             // If you want actual redirection like the other code:
//             // window.location.href = "/home"; 
//           }, 2500);
//         }

//         if (data.status === "rejected") setStatus("ACCESS REJECTED");
//         if (data.status === "expired") setStatus("TOKEN EXPIRED");
//       } catch (err) { console.error(err); }
//     }, 2000);
//   };

//   const currentTheme = theme === "dark" ? styles.dark : styles.light;

//   if (permissionError === "LOCATION_DENIED") {
//     return (
//       <div style={styles.permissionOverlay}>
//         <div style={styles.permissionCard}>
//           <div style={{ fontSize: "40px" }}>📍</div>
//           <h2 style={{ color: "#111" }}>SEC@R Security Protocol</h2>
//           <p style={{ color: "#666" }}>Location access is mandatory for secure vault entry.</p>
//           <button onClick={() => window.location.reload()} style={styles.permissionButton}>
//             RETRY AUTHORIZATION
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={{
//       ...styles.container,
//       backgroundColor: currentTheme.bg,
//       flexDirection: "column", // Added to allow debug payload at bottom
//       transition: "all 0.6s ease"
//     }}>
      
//       {!isVerifying && !showPaymentHub && (
//         <button 
//           onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
//           style={{...styles.themeToggle, color: currentTheme.subText, borderColor: currentTheme.border}}
//         >
//           {theme === "dark" ? "☀️ Light" : "🌙 Dark"}
//         </button>
//       )}

//       {isVerifying && (
//         <div style={styles.successContainer}>
//           <div style={styles.checkIcon}>✓</div>
//           <h1 style={{...styles.welcomeTitle, color: currentTheme.text}}>
//             Welcome back, {userData?.name || "User"}
//           </h1>
//           <p style={styles.welcomeSub}>Identity verified. Loading payment gateway...</p>
//         </div>
//       )}

// {showPaymentHub && (
//   <div style={{
//     ...styles.hubCard, 
//     width: "800px", 
//     minHeight: "450px", 
//     backgroundColor: currentTheme.cardBg, 
//     borderColor: currentTheme.border,
//     position: 'relative'
//   }}>
    
//     {/* PERSISTENT HEADER WITH TIMER */}
//     {!paymentSuccess && (
//       <div style={{
//         position: 'absolute', top: '20px', left: '50%', transform: 'translateX(-50%)',
//         display: 'flex', alignItems: 'center', gap: '10px'
//       }}>
//         <div style={{
//           width: '8px', height: '8px', borderRadius: '50%', 
//           background: paymentTimer < 30 ? '#ff4d4d' : '#25D366',
//           boxShadow: `0 0 10px ${paymentTimer < 30 ? '#ff4d4d' : '#25D366'}`
//         }} />
//         <span style={{
//           color: paymentTimer < 30 ? '#ff4d4d' : currentTheme.subText, 
//           fontSize: '12px', fontWeight: 'bold', fontFamily: 'monospace'
//         }}>
//           SESSION EXPIRES: {formatTime(paymentTimer)}
//         </span>
//       </div>
//     )}

//     {/* THEME TOGGLE */}
//     <button 
//       onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
//       style={{
//         position: 'absolute', top: '20px', right: '20px',
//         background: 'transparent', border: `1px solid ${currentTheme.border}`,
//         color: currentTheme.subText, borderRadius: '20px', padding: '5px 12px',
//         fontSize: '10px', cursor: 'pointer'
//       }}
//     >
//       {theme === "dark" ? "☀️ LIGHT" : "🌙 DARK"}
//     </button>

//     {paymentSuccess ? (
//       <div style={styles.successContainer}>
//         <div style={{...styles.checkIcon, background: '#25D366'}}>✓</div>
//         <h2 style={{color: currentTheme.text}}>TRANSACTION SECURED</h2>
//         <p style={{color: currentTheme.subText}}>Funds routed via {selectedBank}.</p>
//         <button onClick={() => window.location.href = "/shop"} style={styles.permissionButton}>GO TO DASHBOARD</button>
//       </div>
//     ) : (
//       <>
//         {selectedMethod ? (
//           /* STEP 2: CONFIRMATION VIEW */
//           <div style={{textAlign: 'center', animation: 'fadeInUp 0.4s ease', paddingTop: '40px'}}>
//              <span style={styles.brandTag}>FINAL AUTHORIZATION</span>
//              <h2 style={{color: currentTheme.text, marginTop: '10px'}}>Confirm Transfer</h2>
             
//              <div style={{
//                background: theme === 'dark' ? '#111' : '#f9f9f9', 
//                padding: '40px', borderRadius: '15px', 
//                border: `1px solid ${currentTheme.border}`, margin: '25px 0'
//              }}>
//                 <div style={{fontSize: '22px', color: currentTheme.text, fontWeight: '300'}}>
//                   {selectedBank} <span style={{color: '#25D366'}}>•</span> {selectedMethod}
//                 </div>
//                 <div style={{fontSize: '42px', color: currentTheme.text, fontWeight: '900', marginTop: '10px'}}>₹{totalAmount ? parseFloat(totalAmount).toFixed(2) : "0.00"}</div>
//              </div>

//              <div style={{display: 'flex', gap: '15px', justifyContent: 'center'}}>
//                 <button onClick={() => { setSelectedMethod(null); setSelectedBank(null); }} style={{...styles.permissionButton, background: 'transparent', border: `1px solid ${currentTheme.border}`, color: currentTheme.subText}}>BACK</button>
//                 <button 
//                   disabled={isProcessing}
//                   onClick={() => {
//                     setIsProcessing(true);
//                     setTimeout(() => { setIsProcessing(false); setPaymentSuccess(true); }, 2000);
//                   }}
//                   style={{...styles.permissionButton, minWidth: '220px', background: '#25D366'}}
//                 >
//                   {isProcessing ? "VALIDATING..." : "AUTHORIZE PAY"}
//                 </button>
//              </div>
//           </div>
//         ) : (
//           /* STEP 1: BANK SELECTION */
//           <div style={{paddingTop: '30px'}}>
//             <div style={{borderBottom: `1px solid ${currentTheme.border}`, paddingBottom: '20px', marginBottom: '25px'}}>
//               <span style={styles.brandTag}>SEC@R PAYMENTS</span>
//               <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end'}}>
//                 <h2 style={{color: currentTheme.text, margin: 0}}>Select Method</h2>
//                 <div style={{textAlign: 'right'}}>
//                   <span style={{color: currentTheme.subText, fontSize: '11px'}}>AMOUNT</span>
//                   <div style={{color: '#25D366', fontWeight: "900", fontSize: "28px"}}>₹{totalAmount ? parseFloat(totalAmount).toFixed(2) : "0.00"}</div>
//                 </div>
//               </div>
//             </div>

//             <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
//               {Object.keys(paymentOptions).map((bank) => (
//                 <div key={bank} style={{
//                   display: "flex", alignItems: "center", justifyContent: "space-between",
//                   padding: "12px 20px", borderRadius: "12px", background: currentTheme.statusBg,
//                   border: `1px solid ${currentTheme.border}`
//                 }}>
//                   <div style={{ display: "flex", alignItems: "center" }}>
//                     <span style={{ marginRight: '15px' }}>🏦</span>
//                     <span style={{ color: currentTheme.text, fontWeight: "600", fontSize: "14px" }}>{bank}</span>
//                   </div>
//                   <div style={{ display: "flex", gap: "6px" }}>
//                     {paymentOptions[bank].map((method) => (
//                       <button
//                         key={method}
//                         onClick={() => { setSelectedBank(bank); setSelectedMethod(method); }}
//                         style={{
//                           padding: "8px 16px", borderRadius: "8px", border: `1px solid ${currentTheme.border}`,
//                           background: currentTheme.cardBg, color: currentTheme.text,
//                           fontSize: "11px", fontWeight: "bold", cursor: "pointer"
//                         }}
//                       >
//                         {method}
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </>
//     )}
//   </div>
// )}

//       {!isVerifying && !showPaymentHub && (
//         <div style={{ ...styles.card, backgroundColor: currentTheme.cardBg, borderColor: currentTheme.border }}>
//           <div style={styles.left}>
//             <div style={styles.brandTag}>SEC@R PROTOCOL</div>
//             <h2 style={{ ...styles.title, color: currentTheme.text }}>Identity Challenge</h2>
//             <p style={{ ...styles.instruction, color: currentTheme.subText }}>
//               Please scan the QR Code using your SEC@R mobile app.
//             </p>
          
//             <div style={{ ...styles.statusBox, background: currentTheme.statusBg }}>
//               <span style={styles.statusLabel}>PROTOCOL STATUS:</span>
//               <span style={styles.statusValue}>{status}{dots}</span>
//             </div>
//           </div>

//           <div style={{ ...styles.right, background: currentTheme.rightBg, borderColor: currentTheme.border }}>
//             {!isOnline ? (
//               <img src={noInternet} alt="Offline" style={styles.noInternetLogo} />
//             ) : (
//               <div style={styles.qrContainer}>
//                 {qrValue && (
//                   <div style={{ ...styles.qrWrapper, background: "#fff" }}>
//                     <div style={styles.scannerLine} />
//                     <QRCodeCanvas value={qrValue} size={220} level="H" includeMargin={true} />
//                     <img src={logo} alt="logo" style={styles.logo} />
//                   </div>
//                 )}
//                 <div style={styles.timerBarContainer}>
//                   <div style={{...styles.timerBar, width: `${(countdown / 30) * 100}%`}} />
//                 </div>
//                 <p style={styles.timerText}>REFRESH IN: {countdown}s</p>
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       <style>{`
//         @keyframes scan { 0% { top: 0%; } 100% { top: 100%; } }
//         @keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
//       `}</style>
//     </div>
//   );
// }

// const styles = {
//   dark: {
//     bg: "#0f1113", cardBg: "#1c1f23", rightBg: "#16181b",
//     text: "#ffffff", subText: "#888", border: "#333", statusBg: "#25282c"
//   },
//   light: {
//     bg: "#f0f2f5", cardBg: "#ffffff", rightBg: "#fafafa",
//     text: "#111b21", subText: "#667781", border: "#e9edef", statusBg: "#f5f7f9"
//   },
//   container: {
//     height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden", position: "relative", fontFamily: "Inter, sans-serif"
//   },
//   themeToggle: {
//     position: "absolute", top: "30px", right: "30px", padding: "8px 16px", borderRadius: "20px", border: "1px solid", background: "transparent", cursor: "pointer", fontSize: "12px", fontWeight: "bold"
//   },
//   card: {
//     width: "850px", height: "460px", display: "flex", borderRadius: "12px", border: "1px solid", boxShadow: "0 25px 50px rgba(0,0,0,0.2)", animation: "fadeInUp 0.6s ease-out", overflow: "hidden"
//   },
//   left: { flex: 1, padding: "50px", display: "flex", flexDirection: "column", justifyContent: "center" },
//   brandTag: { color: "#25D366", fontSize: "12px", fontWeight: "900", letterSpacing: "2px" },
//   title: { fontSize: "32px", margin: "10px 0 15px 0", fontWeight: "300" },
//   instruction: { fontSize: "14px", lineHeight: "1.6", maxWidth: "300px" },
//   statusBox: { marginTop: "40px", padding: "18px", borderLeft: "3px solid #25D366" },
//   statusLabel: { color: "#888", fontSize: "10px", marginRight: "10px", fontWeight: "bold" },
//   statusValue: { color: "#25D366", fontSize: "13px", fontWeight: "bold" },
//   right: { width: "360px", display: "flex", justifyContent: "center", alignItems: "center", borderLeft: "1px solid" },
//   qrWrapper: { position: "relative", padding: "10px", borderRadius: "4px" },
//   scannerLine: { position: "absolute", left: 0, width: "100%", height: "2px", background: "#25D366", boxShadow: "0 0 15px #25D366", zIndex: 10, animation: "scan 2s linear infinite" },
//   logo: { position: "absolute", top: "50%", left: "50%", width: "55px", height: "55px", transform: "translate(-50%, -50%)", borderRadius: "50%", background: "#fff", padding: "5px" },
//   timerBarContainer: { width: "100%", height: "4px", background: "rgba(0,0,0,0.1)", marginTop: "20px", borderRadius: "2px", overflow: "hidden" },
//   timerBar: { height: "100%", background: "#25D366", transition: "width 1s linear" },
//   timerText: { color: "#888", fontSize: "10px", textAlign: "center", marginTop: "10px" },
  
//   // Hub Styles
//   hubCard: { width: "700px", padding: "40px", borderRadius: "16px", border: "1px solid", animation: "fadeInUp 0.5s ease-out" },
//   hubHeader: { textAlign: "center", marginBottom: "30px" },
//   bankGrid: { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "15px" },
//   bankCard: { padding: "20px", borderRadius: "12px", border: "1px solid", cursor: "pointer", transition: "0.2s", textAlign: "center" },
//   bankIcon: { fontSize: "24px", marginBottom: "10px" },
//   backBtn: { background: "none", border: "none", color: "#888", cursor: "pointer", marginBottom: "10px", padding: 0 },
//   methodList: { display: "flex", flexDirection: "column", gap: "10px" },
//   methodItem: { padding: "15px 20px", borderRadius: "8px", border: "1px solid", display: "flex", justifyContent: "space-between", cursor: "pointer", transition: "0.2s" },

//   successContainer: { textAlign: "center", animation: "fadeInUp 0.8s ease-out" },
//   checkIcon: { width: "80px", height: "80px", borderRadius: "50%", background: "#25D366", color: "white", fontSize: "40px", lineHeight: "80px", margin: "0 auto 20px" },
//   welcomeTitle: { fontSize: "32px", fontWeight: "300" },
//   welcomeSub: { color: "#667781", fontSize: "16px" },
//   permissionOverlay: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.8)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
//   permissionCard: { textAlign: "center", background: "#fff", padding: "40px", borderRadius: "12px" },
//   permissionButton: { marginTop: "20px", padding: "12px 24px", background: "#25D366", border: "none", color: "#fff", borderRadius: "8px", cursor: "pointer" },
// // Add these inside the 'styles' object
// inputField: {
//   width: "100%",
//   padding: "12px",
//   marginTop: "10px",
//   borderRadius: "8px",
//   border: "1px solid #333",
//   background: "#000",
//   color: "#fff",
//   outline: "none"
// },
// bankInterface: {
//   animation: "fadeInUp 0.4s ease-out"
// },
//   debugBox: {
//     marginTop: "30px",
//     width: "850px",
//     maxHeight: "300px",
//     overflow: "auto",
//     fontSize: "11px",
//     background: "#111",
//     color: "#0f0",
//     padding: "15px",
//     borderRadius: "8px",
//     fontFamily: "monospace",
//     border: "1px solid #333",
//     animation: "fadeInUp 0.8s ease-out"
//   }
// };









// WEB ON WEB AND MOBILE


import React, { useEffect, useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { v4 as uuidv4 } from "uuid";
import { API, QR_AUTH_API, SECAR_PAYMENT } from "../Utils/API";
import logo from "../Assets/Secar_logo/logo.png";
import noInternet from "../Assets/no_internet.png";
import { useLocation } from "react-router-dom";

const extractQrToken = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (raw.startsWith("secar-auth:")) {
    return raw.slice("secar-auth:".length).split("&")[0].trim();
  }
  if (raw.includes("token=")) {
    return decodeURIComponent(raw.split("token=")[1].split("&")[0].trim());
  }
  const uuidMatch = raw.match(
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i,
  );
  if (uuidMatch) return uuidMatch[0];
  return raw.split("&")[0].trim();
};

export default function QRLogin() {
  const [status, setStatus] = useState("SYSTEM READY");
  const [countdown, setCountdown] = useState(30);
  const [qrValue, setQrValue] = useState("");
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const location = useLocation();
  const cart = location.state?.cart || JSON.parse(localStorage.getItem("cart") || "[]");
  const totalAmount = location.state?.totalAmount || localStorage.getItem("totalAmount") || 0;

  
  // States for Flow
  const [isVerifying, setIsVerifying] = useState(false);
  const [showPaymentHub, setShowPaymentHub] = useState(false);
  const [userData, setUserData] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [theme, setTheme] = useState("dark");
  const [debugPayload, setDebugPayload] = useState(null);
  const [paymentTimer, setPaymentTimer] = useState(120); // matches SEC@R payment window

  const qrIntervalRef = useRef(null);
  const checkIntervalRef = useRef(null);
  const [dots, setDots] = useState("");
  const [permissionError, setPermissionError] = useState(null);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [bankProfile, setBankProfile] = useState(null);

  const applyApprovedSession = (data) => {
    if (data?.user) setUserData(data.user);
    if (data?.payment_profile) setBankProfile(data.payment_profile);
  };

  const completeApprovedTransition = () => {
    setIsVerifying(true);
    clearInterval(checkIntervalRef.current);
    clearInterval(qrIntervalRef.current);
    setTimeout(() => {
      setIsVerifying(false);
      setShowPaymentHub(true);
      setPaymentTimer(120);
    }, 2500);
  };

  const handleApprovedCheck = (data) => {
    if (data?.user) setUserData(data.user);
    if (data?.payment_profile) {
      setBankProfile(data.payment_profile);
      completeApprovedTransition();
      return true;
    }
    setIsVerifying(true);
    setStatus("LOADING BANKS");
    return false;
  };

  const handleMethodSelect = (bank, method) => {
    if (!bank?.isSecarPartner || !bank?.isRegistered || !method?.available) {
      return;
    }
    setSelectedBank(bank.name);
    setSelectedMethod(method.label);
  };

  const renderOtherBankRow = (bank) => (
    <div
      key={bank.code || bank.name}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "12px 16px",
        borderRadius: "10px",
        background: currentTheme.statusBg,
        border: `1px solid ${currentTheme.border}`,
      }}
    >
      <span style={{ fontSize: "16px" }}>🏦</span>
      <span style={{ color: currentTheme.text, fontWeight: "600", fontSize: "13px" }}>
        {(bank.name || bank.code || "Bank").toUpperCase()}
      </span>
    </div>
  );

  const renderBankRow = (bank) => {
    const canPay = bank.isSecarPartner && bank.isRegistered;
    return (
      <div
        key={bank.code || bank.name}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "14px 18px",
          borderRadius: "12px",
          background: currentTheme.statusBg,
          border: `1px solid ${currentTheme.border}`,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ fontSize: "18px" }}>🏦</span>
            <span style={{ color: currentTheme.text, fontWeight: "700", fontSize: "14px" }}>
              {(bank.name || bank.code || "Bank").toUpperCase()}
            </span>
          </div>
          <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
            {bank.securedBySecar ? (
              <span style={{ fontSize: "10px", fontWeight: "bold", color: "#25D366", background: "rgba(37,211,102,0.12)", padding: "4px 8px", borderRadius: "999px" }}>
                SECURED BY SEC@R
              </span>
            ) : bank.isRegistered && bank.isSecarPartner ? (
              <span style={{ fontSize: "10px", fontWeight: "bold", color: "#93c5fd", background: "rgba(147,197,253,0.12)", padding: "4px 8px", borderRadius: "999px" }}>
                LINKED
              </span>
            ) : null}
            {!bank.isSecarPartner ? (
              <span style={{ fontSize: "10px", fontWeight: "bold", color: "#f59e0b", background: "rgba(245,158,11,0.12)", padding: "4px 8px", borderRadius: "999px" }}>
                NOT SEC@R PARTNER
              </span>
            ) : null}
            {bank.isSecarPartner && !bank.isRegistered ? (
              <span style={{ fontSize: "10px", fontWeight: "bold", color: "#94a3b8", background: "rgba(148,163,184,0.12)", padding: "4px 8px", borderRadius: "999px" }}>
                NOT LINKED
              </span>
            ) : null}
          </div>
        </div>
        {bank.note ? (
          <p style={{ margin: 0, fontSize: "11px", color: currentTheme.subText }}>{bank.note}</p>
        ) : null}
        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
          {(bank.methods || []).map((method) => (
            <button
              key={`${bank.code}-${method.key}`}
              type="button"
              disabled={!canPay || !method.available}
              onClick={() => handleMethodSelect(bank, method)}
              style={{
                padding: "8px 14px",
                borderRadius: "8px",
                border: `1px solid ${method.available && canPay ? "#25D366" : currentTheme.border}`,
                background: method.available && canPay ? "rgba(37,211,102,0.08)" : currentTheme.cardBg,
                color: method.available && canPay ? currentTheme.text : currentTheme.subText,
                fontSize: "11px",
                fontWeight: "bold",
                cursor: method.available && canPay ? "pointer" : "not-allowed",
                opacity: method.available && canPay ? 1 : 0.5,
              }}
            >
              {method.label}
            </button>
          ))}
        </div>
      </div>
    );
  };

  useEffect(() => {
  let interval = null;
  if (showPaymentHub && paymentTimer > 0 && !paymentSuccess) {
    interval = setInterval(() => {
      setPaymentTimer((prev) => prev - 1);
    }, 1000);
  } else if (paymentTimer === 0 && showPaymentHub) {
    const closeWindow = async () => {
      try {
        if (userData?.email) {
          await API.post(SECAR_PAYMENT.CLOSE_PAYMENT_WINDOW, {
            email: userData.email,
            full_name: userData?.name,
          });
        }
      } catch (err) {
        console.error("Failed to close SEC@R payment window", err);
      }
    };
    closeWindow();
    alert("SECURE SESSION EXPIRED — bank payment services are OFF again.");
    setShowPaymentHub(false);
    setSelectedMethod(null);
    setPaymentTimer(120);
  }
  return () => clearInterval(interval);
}, [showPaymentHub, paymentTimer, paymentSuccess, userData]);

useEffect(() => {
  if (!showPaymentHub || bankProfile) {
    return undefined;
  }
  const token = extractQrToken(qrValue);
  if (!token) {
    return undefined;
  }

  let cancelled = false;
  const loadProfile = async () => {
    try {
      const res = await API.get(`${QR_AUTH_API.GET_CHECK_TOKEN}/${token}`);
      const data = res.data;
      if (cancelled || !data?.payment_profile) {
        return;
      }
      setBankProfile(data.payment_profile);
      if (data?.user) {
        setUserData(data.user);
      }
    } catch (err) {
      console.error(err);
    }
  };

  loadProfile();
  const interval = setInterval(loadProfile, 1500);
  return () => {
    cancelled = true;
    clearInterval(interval);
  };
}, [showPaymentHub, bankProfile, qrValue]);

useEffect(() => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // Check for Android or iOS
  if (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)) {
    setIsMobileDevice(true);
  }
}, []);

// Add this inside your QRLogin component
  useEffect(() => {
    const handleVisibilityChange = () => {
      // If the user just switched back to this tab AND we are waiting for a scan
      if (document.visibilityState === "visible" && status === "WAITING FOR SCAN") {
        // Extract token from current qrValue state
        const currentToken = extractQrToken(qrValue);
        if (currentToken) {
           // Force an immediate check instead of waiting for the interval
           checkAuthStatusImmediately(currentToken);
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [status, qrValue]);

  // Helper function to do a single, immediate check
  const checkAuthStatusImmediately = async (token) => {
    try {
      const res = await API.get(`/auth/check/${token}`);
      const data = res.data;

      if (data.status === "approved") {
        if (handleApprovedCheck(data)) {
          return;
        }
      }
    } catch (err) { console.error(err); }
  };

const handleMobileAppLaunch = () => {
  // Extract just the token from your existing qrValue
  const token = extractQrToken(qrValue);
  // Replace 'secarapp://' with your actual app scheme configured in React Native
  window.location.href = `secarapp://auth?token=${token}`;
};


// Helper to format seconds to MM:SS
const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
};

  // 1. Connection Monitoring
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // 2. Lifecycle & QR Generation
  useEffect(() => {
    if (!isOnline) {
      setStatus("OFFLINE");
      clearInterval(qrIntervalRef.current);
      clearInterval(checkIntervalRef.current);
      return;
    }
    generateQR();
    qrIntervalRef.current = setInterval(generateQR, 30000);
    return () => {
      clearInterval(qrIntervalRef.current);
      clearInterval(checkIntervalRef.current);
    };
  }, [isOnline]);

  // 3. UI Animations (Dots & Timer)
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? "" : prev + "."));
    }, 500);
    const timer = setInterval(() => {
      if (isOnline) setCountdown((prev) => (prev <= 1 ? 30 : prev - 1));
    }, 1000);
    return () => {
      clearInterval(interval);
      clearInterval(timer);
    };
  }, [isOnline]);

  // --- Security & Data Helpers ---
  const getIP = async () => {
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      return data.ip;
    } catch { return "0.0.0.0"; }
  };

  const getLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) return reject("Not supported");
      navigator.geolocation.getCurrentPosition(
        (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy }),
        (err) => reject(err),
        { enableHighAccuracy: true, timeout: 10000 }
      );
    });
  };

  // Add this helper function above your generateQR function
const getMaximumWebData = async () => {
  const nav = navigator;
  const screen = window.screen;
  const conn = nav.connection || nav.mozConnection || nav.webkitConnection || {};
  
  // 1. Try to fetch Battery Status (Supported in Chrome/Edge, not Safari)
  let batteryData = { supported: false };
  try {
    if (nav.getBattery) {
      const b = await nav.getBattery();
      batteryData = {
        supported: true,
        level: Math.round(b.level * 100) + "%",
        charging: b.charging,
        chargingTime: b.chargingTime,
        dischargingTime: b.dischargingTime
      };
    }
  } catch (e) { /* silent fail */ }

  // 2. Extract GPU / Graphics Card Info via WebGL (Highly unique)
  let gpuRenderer = "unknown";
  let gpuVendor = "unknown";
  try {
    const canvas = document.createElement("canvas");
    const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    if (gl) {
      const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
      if (debugInfo) {
        gpuVendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
        gpuRenderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
      }
    }
  } catch (e) { /* silent fail */ }

  return {
    hardware: {
      cpuLogicalCores: nav.hardwareConcurrency || "unknown",
      ramGB: nav.deviceMemory || "unknown",
      maxTouchPoints: nav.maxTouchPoints || 0,
      gpuVendor: gpuVendor,
      gpuRenderer: gpuRenderer,
      battery: batteryData
    },
    screenMetrics: {
      width: screen.width,
      height: screen.height,
      availWidth: screen.availWidth,
      availHeight: screen.availHeight,
      colorDepth: screen.colorDepth,
      pixelDepth: screen.pixelDepth,
      pixelRatio: window.devicePixelRatio || 1,
      isExtendedDisplay: screen.isExtended || false
    },
    networkTelemetry: {
      connectionType: conn.type || "unknown",
      effectiveSpeed: conn.effectiveType || "unknown",
      downlinkMbps: conn.downlink || "unknown",
      roundTripTimeMs: conn.rtt || "unknown",
      dataSaverActive: conn.saveData || false
    },
    systemEnvironment: {
      platform: nav.platform,
      vendor: nav.vendor,
      osLanguage: nav.language,
      installedLanguages: nav.languages || [],
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      timeOffsetMinutes: new Date().getTimezoneOffset(),
      pdfViewerEnabled: nav.pdfViewerEnabled || false,
      cookiesEnabled: nav.cookieEnabled || false,
      doNotTrackStatus: nav.doNotTrack || "unspecified"
    },
    browserAPISupport: {
      bluetooth: !!nav.bluetooth, 
      usb: !!nav.usb,             
      nfc: 'NDEFReader' in window, 
      gamepad: !!nav.getGamepads  
    },
    threatDetection: {
      isBotOrWebdriver: nav.webdriver || false,
      userAgent: nav.userAgent
    }
  };
};

// ----------------------------------------------------
// YOUR UPDATED generateQR FUNCTION
// ----------------------------------------------------

const generateQR = async () => {
  if (!isOnline || isVerifying || showPaymentHub) return;
  
  try {
    const ip = await getIP();
    let location;
    try {
      location = await getLocation();
    } catch (err) {
      setPermissionError("LOCATION_DENIED");
      return;
    }

    setPermissionError(null);
    // 1. Fetch the massive environment profile
    const deepEnv = await getMaximumWebData();
    // 2. Build the ultra-secure payload
    const payload = {
      sessionId: uuidv4(),
      ip,
      location,
      environment: deepEnv,
    
      securityFingerprint: btoa(
        `${deepEnv.hardware.gpuRenderer}|${deepEnv.screenMetrics.width}x${deepEnv.screenMetrics.height}|${deepEnv.systemEnvironment.timezone}`
      ),
      
      meta: { 
        timestamp: new Date().toISOString(), 
        referrer: document.referrer || "direct" 
      }
    };

    setDebugPayload(payload);

    const res = await API.post(QR_AUTH_API.GET_GENERATE_QR, payload);
    const data = res.data;
    
    // secar-auth: token scans reliably in the mobile app (no broken localhost URL in QR)
    setQrValue(`secar-auth:${data.token}`);
    setCountdown(30);
    setStatus("WAITING FOR SCAN");
    
    startChecking(data.token);
  } catch (err) {
    setStatus("SERVER ERROR");
  }
};
  const startChecking = (token) => {
    if (checkIntervalRef.current) clearInterval(checkIntervalRef.current);
    checkIntervalRef.current = setInterval(async () => {
      try {
        // const res = await API.get(`/auth/check/${token}`);
        const res = await API.get(`${QR_AUTH_API.GET_CHECK_TOKEN}/${token}`);
        const data = res.data;

        if (data.status === "approved") {
          if (handleApprovedCheck(data)) {
            return;
          }
        }

        if (data.status === "rejected") setStatus("ACCESS REJECTED");
        if (data.status === "expired") setStatus("TOKEN EXPIRED");
      } catch (err) { console.error(err); }
    }, 2000);
  };

  const currentTheme = theme === "dark" ? styles.dark : styles.light;

  if (permissionError === "LOCATION_DENIED") {
    return (
      <div style={styles.permissionOverlay}>
        <div style={styles.permissionCard}>
          <div style={{ fontSize: "40px" }}>📍</div>
          <h2 style={{ color: "#111" }}>SEC@R Security Protocol</h2>
          <p style={{ color: "#666" }}>Location access is mandatory for secure vault entry.</p>
          <button onClick={() => window.location.reload()} style={styles.permissionButton}>
            RETRY AUTHORIZATION
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      ...styles.container,
      backgroundColor: currentTheme.bg,
      flexDirection: "column", // Added to allow debug payload at bottom
      transition: "all 0.6s ease"
    }}>
      
      {!isVerifying && !showPaymentHub && (
        <button 
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          style={{...styles.themeToggle, color: currentTheme.subText, borderColor: currentTheme.border}}
        >
          {theme === "dark" ? "☀️ Light" : "🌙 Dark"}
        </button>
      )}

      {isVerifying && (
        <div style={styles.successContainer}>
          <div style={styles.checkIcon}>✓</div>
          <h1 style={{...styles.welcomeTitle, color: currentTheme.text}}>
            Welcome back, {userData?.name || "User"}
          </h1>
          <p style={styles.welcomeSub}>Identity verified. Loading payment gateway...</p>
        </div>
      )}

{showPaymentHub && (
  <div style={{
    ...styles.hubCard, 
    width: "800px", 
    minHeight: "450px", 
    backgroundColor: currentTheme.cardBg, 
    borderColor: currentTheme.border,
    position: 'relative'
  }}>
    
    {/* PERSISTENT HEADER WITH TIMER */}
    {!paymentSuccess && (
      <div style={{
        position: 'absolute', top: '20px', left: '50%', transform: 'translateX(-50%)',
        display: 'flex', alignItems: 'center', gap: '10px'
      }}>
        <div style={{
          width: '8px', height: '8px', borderRadius: '50%', 
          background: paymentTimer < 30 ? '#ff4d4d' : '#25D366',
          boxShadow: `0 0 10px ${paymentTimer < 30 ? '#ff4d4d' : '#25D366'}`
        }} />
        <span style={{
          color: paymentTimer < 30 ? '#ff4d4d' : currentTheme.subText, 
          fontSize: '12px', fontWeight: 'bold', fontFamily: 'monospace'
        }}>
          SESSION EXPIRES: {formatTime(paymentTimer)}
        </span>
      </div>
    )}

    {/* THEME TOGGLE */}
    <button 
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      style={{
        position: 'absolute', top: '20px', right: '20px',
        background: 'transparent', border: `1px solid ${currentTheme.border}`,
        color: currentTheme.subText, borderRadius: '20px', padding: '5px 12px',
        fontSize: '10px', cursor: 'pointer'
      }}
    >
      {theme === "dark" ? "☀️ LIGHT" : "🌙 DARK"}
    </button>

    {paymentSuccess ? (
      <div style={styles.successContainer}>
        <div style={{...styles.checkIcon, background: '#25D366'}}>✓</div>
        <h2 style={{color: currentTheme.text}}>TRANSACTION SECURED</h2>
        <p style={{color: currentTheme.subText}}>Funds routed via {selectedBank}.</p>
        <button onClick={() => window.location.href = "/shop"} style={styles.permissionButton}>GO TO DASHBOARD</button>
      </div>
    ) : (
      <>
        {selectedMethod ? (
          /* STEP 2: CONFIRMATION VIEW */
          <div style={{textAlign: 'center', animation: 'fadeInUp 0.4s ease', paddingTop: '40px'}}>
             <span style={styles.brandTag}>FINAL AUTHORIZATION</span>
             <h2 style={{color: currentTheme.text, marginTop: '10px'}}>Confirm Transfer</h2>
             
             <div style={{
               background: theme === 'dark' ? '#111' : '#f9f9f9', 
               padding: '40px', borderRadius: '15px', 
               border: `1px solid ${currentTheme.border}`, margin: '25px 0'
             }}>
                <div style={{fontSize: '22px', color: currentTheme.text, fontWeight: '300'}}>
                  {selectedBank} <span style={{color: '#25D366'}}>•</span> {selectedMethod}
                </div>
                <div style={{fontSize: '42px', color: currentTheme.text, fontWeight: '900', marginTop: '10px'}}>₹{totalAmount ? parseFloat(totalAmount).toFixed(2) : "0.00"}</div>
             </div>

             <div style={{display: 'flex', gap: '15px', justifyContent: 'center'}}>
                <button onClick={() => { setSelectedMethod(null); setSelectedBank(null); }} style={{...styles.permissionButton, background: 'transparent', border: `1px solid ${currentTheme.border}`, color: currentTheme.subText}}>BACK</button>
                <button 
                  disabled={isProcessing}
                  onClick={() => {
                    setIsProcessing(true);
                    setTimeout(() => { setIsProcessing(false); setPaymentSuccess(true); }, 2000);
                  }}
                  style={{...styles.permissionButton, minWidth: '220px', background: '#25D366'}}
                >
                  {isProcessing ? "VALIDATING..." : "AUTHORIZE PAY"}
                </button>
             </div>
          </div>
        ) : (
          /* STEP 1: BANK SELECTION */
          <div style={{paddingTop: '30px'}}>
            <div style={{borderBottom: `1px solid ${currentTheme.border}`, paddingBottom: '20px', marginBottom: '25px'}}>
              <span style={styles.brandTag}>SEC@R PAYMENTS</span>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end'}}>
                <h2 style={{color: currentTheme.text, margin: 0}}>Select Method</h2>
                <div style={{textAlign: 'right'}}>
                  <span style={{color: currentTheme.subText, fontSize: '11px'}}>AMOUNT</span>
                  <div style={{color: '#25D366', fontWeight: "900", fontSize: "28px"}}>₹{totalAmount ? parseFloat(totalAmount).toFixed(2) : "0.00"}</div>
                </div>
              </div>
            </div>

            {!bankProfile ? (
              <p style={{ color: currentTheme.subText, fontSize: '13px' }}>Loading your registered banks…</p>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: "18px", maxHeight: "320px", overflowY: "auto", paddingRight: "4px" }}>
                {bankProfile.partner_banks?.length > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <span style={{ color: currentTheme.subText, fontSize: "11px", fontWeight: "bold", letterSpacing: "1px" }}>
                      YOUR SEC@R PARTNER BANKS
                    </span>
                    {bankProfile.partner_banks.map(renderBankRow)}
                  </div>
                ) : (
                  <p style={{ color: currentTheme.subText, fontSize: '12px' }}>
                    No SEC@R partner bank linked to your mobile profile yet.
                  </p>
                )}

                {(() => {
                  const otherBanks = [
                    ...(bankProfile.other_banks || []),
                    ...(bankProfile.partner_not_linked || []).map((bank) => ({
                      code: bank.code,
                      name: bank.name || bank.code,
                    })),
                  ];
                  if (otherBanks.length === 0) return null;
                  return (
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                      <span style={{ color: currentTheme.subText, fontSize: "11px", fontWeight: "bold", letterSpacing: "1px" }}>
                        OTHER BANKS
                      </span>
                      {otherBanks.map(renderOtherBankRow)}
                    </div>
                  );
                })()}
              </div>
            )}
          </div>
        )}
      </>
    )}
  </div>
)}

      {!isVerifying && !showPaymentHub && (
        <div style={{ ...styles.card, backgroundColor: currentTheme.cardBg, borderColor: currentTheme.border }}>
          <div style={styles.left}>
            <div style={styles.brandTag}>SEC@R PROTOCOL</div>
            <h2 style={{ ...styles.title, color: currentTheme.text }}>Identity Challenge</h2>
            <p style={{ ...styles.instruction, color: currentTheme.subText }}>
              Please scan the QR Code using your SEC@R mobile app.
            </p>
          
            <div style={{ ...styles.statusBox, background: currentTheme.statusBg }}>
              <span style={styles.statusLabel}>PROTOCOL STATUS:</span>
              <span style={styles.statusValue}>{status}{dots}</span>
            </div>
          </div>

          <div style={{ ...styles.right, background: currentTheme.rightBg, borderColor: currentTheme.border }}>
            {!isOnline ? (
              <img src={noInternet} alt="Offline" style={styles.noInternetLogo} />
            ) : (
            //   <div style={styles.qrContainer}>
            //     {qrValue && (
            //       <div style={{ ...styles.qrWrapper, background: "#fff" }}>
            //         <div style={styles.scannerLine} />
            //         <QRCodeCanvas value={qrValue} size={220} level="H" includeMargin={true} />
            //         <img src={logo} alt="logo" style={styles.logo} />
            //       </div>
            //     )}
            //     <div style={styles.timerBarContainer}>
            //       <div style={{...styles.timerBar, width: `${(countdown / 30) * 100}%`}} />
            //     </div>
            //     <p style={styles.timerText}>REFRESH IN: {countdown}s</p>
            //   </div>
            // )}  
            <div style={styles.qrContainer}>
      {qrValue && (
        isMobileDevice ? (
          /* --- MOBILE VIEW: SHOW BUTTON --- */
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <div style={styles.checkIcon}>📱</div>
            <h3 style={{ color: currentTheme.text }}>Mobile Detected</h3>
            <p style={{ color: currentTheme.subText, fontSize: '12px', marginBottom: '20px' }}>
              Tap below to securely authenticate using the SEC@R app on this device.
            </p>
            <button 
              onClick={handleMobileAppLaunch} 
              style={{...styles.permissionButton, width: '100%'}}
            >
              OPEN SEC@R APP
            </button>
          </div>
        ) : (
          /* --- DESKTOP VIEW: SHOW QR CODE --- */
          <div style={{ ...styles.qrWrapper, background: "#fff" }}>
            <div style={styles.scannerLine} />
            <QRCodeCanvas value={qrValue} size={220} level="H" includeMargin={true} />
            <img src={logo} alt="logo" style={styles.logo} />
          </div>
        )
      )}
      
      {/* Keep timer visible for both */}
      <div style={styles.timerBarContainer}>
        <div style={{...styles.timerBar, width: `${(countdown / 30) * 100}%`}} />
      </div>
      <p style={styles.timerText}>REFRESH IN: {countdown}s</p>
    </div>
  )}
          </div>
        </div>
      )}

      <style>{`
        @keyframes scan { 0% { top: 0%; } 100% { top: 100%; } }
        @keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </div>
  );
}

const styles = {
  dark: {
    bg: "#0f1113", cardBg: "#1c1f23", rightBg: "#16181b",
    text: "#ffffff", subText: "#888", border: "#333", statusBg: "#25282c"
  },
  light: {
    bg: "#f0f2f5", cardBg: "#ffffff", rightBg: "#fafafa",
    text: "#111b21", subText: "#667781", border: "#e9edef", statusBg: "#f5f7f9"
  },
  container: {
    height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden", position: "relative", fontFamily: "Inter, sans-serif"
  },
  themeToggle: {
    position: "absolute", top: "30px", right: "30px", padding: "8px 16px", borderRadius: "20px", border: "1px solid", background: "transparent", cursor: "pointer", fontSize: "12px", fontWeight: "bold"
  },
  card: {
    width: "850px", height: "460px", display: "flex", borderRadius: "12px", border: "1px solid", boxShadow: "0 25px 50px rgba(0,0,0,0.2)", animation: "fadeInUp 0.6s ease-out", overflow: "hidden"
  },
  left: { flex: 1, padding: "50px", display: "flex", flexDirection: "column", justifyContent: "center" },
  brandTag: { color: "#25D366", fontSize: "12px", fontWeight: "900", letterSpacing: "2px" },
  title: { fontSize: "32px", margin: "10px 0 15px 0", fontWeight: "300" },
  instruction: { fontSize: "14px", lineHeight: "1.6", maxWidth: "300px" },
  statusBox: { marginTop: "40px", padding: "18px", borderLeft: "3px solid #25D366" },
  statusLabel: { color: "#888", fontSize: "10px", marginRight: "10px", fontWeight: "bold" },
  statusValue: { color: "#25D366", fontSize: "13px", fontWeight: "bold" },
  right: { width: "360px", display: "flex", justifyContent: "center", alignItems: "center", borderLeft: "1px solid" },
  qrWrapper: { position: "relative", padding: "10px", borderRadius: "4px" },
  scannerLine: { position: "absolute", left: 0, width: "100%", height: "2px", background: "#25D366", boxShadow: "0 0 15px #25D366", zIndex: 10, animation: "scan 2s linear infinite" },
  logo: { position: "absolute", top: "50%", left: "50%", width: "55px", height: "55px", transform: "translate(-50%, -50%)", borderRadius: "50%", background: "#fff", padding: "5px" },
  timerBarContainer: { width: "100%", height: "4px", background: "rgba(0,0,0,0.1)", marginTop: "20px", borderRadius: "2px", overflow: "hidden" },
  timerBar: { height: "100%", background: "#25D366", transition: "width 1s linear" },
  timerText: { color: "#888", fontSize: "10px", textAlign: "center", marginTop: "10px" },
  
  // Hub Styles
  hubCard: { width: "700px", padding: "40px", borderRadius: "16px", border: "1px solid", animation: "fadeInUp 0.5s ease-out" },
  hubHeader: { textAlign: "center", marginBottom: "30px" },
  bankGrid: { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "15px" },
  bankCard: { padding: "20px", borderRadius: "12px", border: "1px solid", cursor: "pointer", transition: "0.2s", textAlign: "center" },
  bankIcon: { fontSize: "24px", marginBottom: "10px" },
  backBtn: { background: "none", border: "none", color: "#888", cursor: "pointer", marginBottom: "10px", padding: 0 },
  methodList: { display: "flex", flexDirection: "column", gap: "10px" },
  methodItem: { padding: "15px 20px", borderRadius: "8px", border: "1px solid", display: "flex", justifyContent: "space-between", cursor: "pointer", transition: "0.2s" },

  successContainer: { textAlign: "center", animation: "fadeInUp 0.8s ease-out" },
  checkIcon: { width: "80px", height: "80px", borderRadius: "50%", background: "#25D366", color: "white", fontSize: "40px", lineHeight: "80px", margin: "0 auto 20px" },
  welcomeTitle: { fontSize: "32px", fontWeight: "300" },
  welcomeSub: { color: "#667781", fontSize: "16px" },
  permissionOverlay: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.8)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
  permissionCard: { textAlign: "center", background: "#fff", padding: "40px", borderRadius: "12px" },
  permissionButton: { marginTop: "20px", padding: "12px 24px", background: "#25D366", border: "none", color: "#fff", borderRadius: "8px", cursor: "pointer" },
// Add these inside the 'styles' object
inputField: {
  width: "100%",
  padding: "12px",
  marginTop: "10px",
  borderRadius: "8px",
  border: "1px solid #333",
  background: "#000",
  color: "#fff",
  outline: "none"
},
bankInterface: {
  animation: "fadeInUp 0.4s ease-out"
},
  debugBox: {
    marginTop: "30px",
    width: "850px",
    maxHeight: "300px",
    overflow: "auto",
    fontSize: "11px",
    background: "#111",
    color: "#0f0",
    padding: "15px",
    borderRadius: "8px",
    fontFamily: "monospace",
    border: "1px solid #333",
    animation: "fadeInUp 0.8s ease-out"
  }
};
